import React, { PureComponent, Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    View,
    StyleSheet,
		Platform
} from 'react-native';
import {
    JDText,
    JDImage,
    JDTouchable,
    JDNativeSystem,
    JDShare,
		JDJumping
} from '@jdreact/jdreact-core-lib';
import { get } from '../../common/fetch';
import { time_str, mta } from '../../common/utils';
import TheatreAddr from '../common/theatre-addr';
import OrderScore from './order-score';
import LigntLicence from '../common/light-licence';
import { ImageList as ImageInfos, utils } from '@ltfe/ltfe-core-lib';
import TicketPurchaseNotice from '../../components/order/ticketPurchaseNotice';
const { pt } = utils;
import sgmReport from '../../common/sgmUtil';

// 影院状态 0-待完善 1-正常 2-停售
const cinemaSaleStatusMap = {
    uncomplete: 0,
    normal: 1,
    sellout: 2
};


function getLabel(score) {
    let label = '看过，';

    if (score > 8) { // 9 10
        label += '棒极了';
    } else if (score > 6) { // 7 8
        label += '还不错';
    } else if (score > 4) { // 5 6
        label += '一般般';
    } else if (score > 2) { // 3 4
        label += '比较差';
    } else { // 1 2
        label += '超烂的';
    }

    return label;
}

class OrderAddr extends PureComponent {
    state = {
        isShowScoreDialog: false,
        isShowLicenceDialog: false,
        url: '',
        erpID: ''
    }

    static defaultProps = {
        info: {
            movieId: '',
            movieName: '',
            orderStatus: '',
            cinemaName: '',
            cinemaAddress: '',
            orderNo: '',
            orderPayTime: '',
            onlinePayFeeMoney: 0,
            discountFeeMoney: 0,
            cinemaLat: null,
            cinemaLon: null,
            cinemaPhone: '',
            venderId: '',
            venderName: ''
        }
    }

    render() {
        const {
            cinemaId,
            movieId,
            movieName,
            orderStatus,
            cinemaName,
            cinemaAddress,
            orderNo,
            orderPayTime,
            onlinePayFeeMoney,
            discountFeeMoney,
            cinemaLat,
            cinemaLon,
            cinemaPhone,
            venderId,
            venderName
        } = this.props.info;
        const { starLevel, info, detailsHeight } = this.props;
        const { isShowScoreDialog, isShowLicenceDialog } = this.state;
        const { erpOrderId } = this.props;

        this.state.erpID = erpOrderId;

		    return (
				    <View>
						    {
								    !this.props.shadowBean ?
										    <>
												    <View style={ st.bg }>
														    <OrderScore dialogShow={ isShowScoreDialog }
														                closeScoreDialog={ () => this._closeDialog('isShowScoreDialog') }
														                movieId={ movieId }
														                movieName={ movieName } />
														    {
																    orderStatus === 5
																		    ? (
																				    <JDTouchable onPress={ () => {
																						    if (starLevel !== -1) return;
																						    mta('OrdDeStar', 'Order', '', `${erpOrderId}`);
																						    this._showDialog('isShowScoreDialog');
																				    } }>
																						    <View style={ st.score_box }>
																								    <View><JDText style={ st.score_t }>我要评分</JDText></View>
																								    <View>
																										    {
																												    (starLevel !== -1)
																														    ? (
																																    <JDText style={ st.score }>{Number(starLevel).toFixed(1)}分，{getLabel(starLevel)}！</JDText>
																														    )
																														    : (
																																    <JDImage source={ img.rightArrow } />
																														    )
																										    }
																								    </View>
																						    </View>
																				    </JDTouchable>
																		    )
																		    : null
														    }
														    {/* <JDTouchable onPress={() => {
                            if (orderStatus==='ORDER_COMP' && starLevel!==-1) return;
                            this._showScoreDialog('isShowScoreDialog');
                        }}>
                        <View style={[st.score_box]}>
                            <View><JDText style={[st.score_t]}>我要评分</JDText></View>
                                <View>
                                    {
                                        (orderStatus==='ORDER_COMP' && starLevel!==-1) ? (
                                            <JDText style={[st.score]}>5分，棒极了！</JDText>
                                        ) : (
                                            <JDImage source={img.rightArrow}></JDImage>
                                        )
                                    }
                                </View>
                        </View>
                    </JDTouchable> */}
														    <View style={ st.addr_box }>
																    <View>
																		    <TheatreAddr addrInfo={ {
                                            cinemaId,
																				    tel: cinemaPhone,
																				    cinemaName: cinemaName,
																				    address: cinemaAddress,
																				    lng: cinemaLon,
																				    lat: cinemaLat,
																				    promo: [],
																				    locatPress: () => {
																						    mta('OrdDeAddress', 'Order', `${orderStatus}`, `${erpOrderId}`);
																				    },
																				    telPress: () => {
																						    mta('OrdDeTel', 'Order', `${orderStatus}`, `${erpOrderId}`);
																				    }
																		    } } toMovieList={this.toMovieList} />
																    </View>
														    </View>
														    <View style={ st.detail_box }>
																    <View>
																		    <View style={ st.detail_tbox }>
																				    <JDText style={ st.detail_t }>订单详情</JDText>
																				    <View style={ st.shareicon }>
																						    <JDTouchable onPress={ () => {
																								    this.share(orderNo);
																						    } }
																						                 hitSlop={ { top: 10, bottom: 10, left: 10, right: 5 } }>
																								    <JDImage source={ img.navShare } style={ st.nav_btn } />
																						    </JDTouchable>
																				    </View>
																		    </View>
																		    <View style={ st.line }>
																				    <JDText style={ st.txt_title }>订单号: </JDText>
																				    <JDText style={ st.detail_d }>{orderNo}</JDText>
																		    </View>
																		    <View style={ st.line }>
																				    <JDText style={ st.txt_title }>下单时间: </JDText>
																				    <JDText style={ st.detail_d }>{time_str(orderPayTime)}</JDText>
																		    </View>
																		    <View style={ st.fee }>
																				    {
																						    info.totalAmount > 0 &&
																						    <View style={ st.line }>
																								    <JDText style={ st.txt_title }>总金额: </JDText>
																								    <JDText style={ st.detail_d }>&yen;{info.totalAmount / 100}
																								    </JDText>
																						    </View>
																				    }

																				    {
																						    info.movieBeanMoney > 0 &&
																						    <View style={ st.line }>
																								    <JDText style={ st.txt_title }>影豆: </JDText>
																								    <JDText style={ st.detail_d }>&yen;{info.movieBeanMoney / 100}</JDText>
																						    </View>
																				    }

																				    {
																						    info.discountFeeMoney > 0 &&
																						    <View style={ st.line }>
																								    <JDText style={ st.txt_title }>优惠: </JDText>
																								    <JDText style={ st.detail_d }>&yen;{info.discountFeeMoney / 100}</JDText>
																						    </View>
																				    }
																				    {
																						    info.jingBeanMoney > 0 &&
																						    <View style={ st.line }>
																								    <JDText style={ st.txt_title }>京豆: </JDText>
																								    <JDText style={ st.detail_d }>&yen;{info.jingBeanMoney / 100}</JDText>
																						    </View>
																				    }
																				    {
																						    info.certMoney > 0 &&
																						    <View style={ st.line }>
																								    <JDText style={ st.txt_title }>兑换券: </JDText>
																								    <JDText style={ st.detail_d }>&yen;{info.certMoney / 100}</JDText>
																						    </View>
																				    }
																				    <View style={ st.line }>
																						    <JDText style={ st.txt_title }>实付款: </JDText>
																						    <JDText style={ st.detail_d }>&yen;{onlinePayFeeMoney / 100}</JDText>
																				    </View>
                                            <View style={{height: 10}}></View>
																		    </View>
																    </View>
														    </View>
												    </View>
                            <View style={{height: 10}}></View>
                            <View style={{backgroundColor: '#fff'}}>
                                <TicketPurchaseNotice />
                                <View style={{ paddingLeft: 10, paddingRight: 10 }}>
                                    <OnlineKefu
                                        orderStatus={orderStatus}
                                        erpOrderId={erpOrderId}
                                        erpOrderId={erpOrderId}
                                        shadowBean={this.props.shadowBean}
                                        toOnline={()=> this._toOnline(erpOrderId)}
                                    />
                                </View>
                                <View style={{height: 10}}></View>
                            </View>

                            <View style={{backgroundColor: '#F6F6F6', height: 10}}></View>
												    <ImageInfos code={ 'ca698daa6c6042c28f7fdf4b2f55a35f' } mode={ 'pro' } channel={ 'JDReactMovie' } />
												    <View style={ [st.licence, st.bg] }>
														    {
																    venderId
																		    ? (
																				    <LigntLicence dialogShow={ isShowLicenceDialog }
																				                  closeLicenceDialog={ () => this._closeDialog('isShowLicenceDialog') }
																				                  venderId={ venderId } />
																		    )
																		    : null
														    }
														    <JDText style={ st.licence_text }>本票品由{venderName}提供，</JDText>
														    <JDTouchable onPress={ () => { this._showDialog('isShowLicenceDialog'); } }><JDText style={ st.blue }>查看证照信息</JDText></JDTouchable>
												    </View>
										    </> :
										    <View style={[st.fixedBottom, {paddingTop: detailsHeight}]}>
												    <View style={st.onlineBottom}>
														    <OnlineKefu
																    orderStatus={orderStatus}
																    erpOrderId={erpOrderId}
																    erpOrderId={erpOrderId}
																    shadowBean={this.props.shadowBean}
																    toOnline={()=> this._toOnline(erpOrderId)}
														    />
												    </View>
												    <View style={st.fixedTips}>
														    <JDText style={ st.fiexdText }>本商品由影豆商城提供，更多详细信息请到</JDText>
                                                            <JDTouchable onPress={ this.openApplet }>
														        <JDText style={ [st.fiexdText, st.fiexdTextBlue] }>影豆商城小程序</JDText>
                                                            </JDTouchable>
														    <JDText style={ st.fiexdText }>查看</JDText>
												    </View>
										    </View>
						    }
				    </View>
		    );
    }

    componentDidMount() {
        get('getOrderShareMsg', { erpOrderId: this.state.erpID }
        ).then(res => {
            this.setState({
                url: res.data?.sharePicAddr || ''
            });
        });
        if(!this.state.erpID){
            sgmReport('1001', {function_id: 'getOrderShareMsg',message:'缺少参数erpOrderId'}, 3)
        }
    }

    _showDialog = key => {
        if (key === 'isShowLicenceDialog') {
            this.props.setZindexFun(true);
        }
        this.setState({
            [key]: true
        });
    }

    _closeDialog = key => {
        if (key === 'isShowLicenceDialog') {
            this.props.setZindexFun(false);
        }
        this.setState({
            [key]: false
        });
    }

    _callTel = (tel) => {
        JDNativeSystem.callPhone(tel);
    }


    //打开影豆商城小程序
    openApplet = () => {
        const url = `https://mini-app-static.jd.com/apps/mpshare/index.html?category=jump&des=jdmp&vapptype=1&appId=ED2AA7211D811DD081E8B321515A070C&path=&scene=1044`;
        JDJumping.jumpToWeb(url).catch(err => tip(err));
    }

    _toOnline = (erpOrderId) => {
        // 'openApp.jdMobile://virtual?params={"category":"jump","des":"im","entry":"sdk_jd_yingpiao", "orderID":'+this.orderDetail.jdErpId+'}'
        // const url = `openApp.jdMobile://virtual?params={"category":"jump","des":"im","entry":"sdk_jd_yingpiao","orderID":${erpOrderId}}`;
        // JDJumping.jumpToOpenapp(url).catch(err => alert(err));
        location.href = `//chat.jd.com/chat/index.action?entry=${erpOrderId}`;
    }

    share(orderId) {
        if (this.state.url !== '') {
            mta('OrderShare', 'Order', '订单分享按钮', `${orderId}`);
            JDShare.sendDirectShare({
                title: '',
                content: '',
                url: '',
                img: '',
                mpIconUrl: '',
                channel: 'QRCode',
                qrparam: {
                    qr_direct: this.state.url
                }
            });
            JDShare.singleShare(
                'QRCode',
                'https://m.jd.com/',
                'Test ShowShareDialog Title',
                'Test ShowShareDialog Summary',
                'https://m.360buyimg.com/mobilecms/s80x80_jfs/t2401/304/893337264/4249/3d40e699/56333ef6Nba360270.png',
                '',
                '7',
                undefined,
                undefined,
                '',
                '',
                '',
                // "https://m.360buyimg.com/mobilecms/s80x80_jfs/t2401/304/893337264/4249/3d40e699/56333ef6Nba360270.png",
                '',
                '',
                // "https://m.360buyimg.com/mobilecms/jfs/t4072/112/1591679829/43588/55e4f4f4/588065f1Nb0e15eaa.png",
                '',
                '',
                'Test moreSingleShare Title',
                'Test moreSingleShare Summary',
                // 'http://m.360buyimg.com/img/jfs/t1/42401/2/1973/136040/5cc82099E0caf0d6c/dd9773319797e131.png'
                this.state.url
            ).then(() => {}, () => {});
        }
    }

    toMovieList = () => {
        const { cinemaId, cinemaSaleStatus } = this.props.info || {};

        if (+cinemaSaleStatus === cinemaSaleStatusMap.normal && cinemaId) {
            this.context.router.toMovieList({ cinemaId });
        } else {
            this.context.router.toIndex();
        }
        mta('OrdCinema', 'Order');
    }
};

// 在线客服
class OnlineKefu extends Component {
		constructor(props) {
				super(props);
				this.props = props
		}
		render() {
				const btnClass = this.props.shadowBean ? st.new_btn_box : st.btn_box
				return (
						<View style={ btnClass }>
								<JDTouchable
										style={ { width: '100%' } }
										onPress={ () => { mta('OrdDeService', 'Order', `${this.props.orderStatus}`, `${this.props.erpOrderId}`); this.props.toOnline(this.props.erpOrderId); } }>
										<View style={ st.btn }>
												<JDText style={ st.btn_text }>在线客服</JDText>
										</View>
								</JDTouchable>
						</View>
				)
		}
}
const img = {
    rightArrow: require('../../img/order/right.png'),
    navShare: require('../../img/ordershare.png')
};
const st = StyleSheet.create({
    bg: {
        backgroundColor: '#fff'
    },
    score_box: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottomColor: 'rgba(0,0,0,0.1)',
        borderBottomWidth: pt(1),
        height: pt(46),
        paddingLeft: pt(11),
        paddingRight: pt(9)

    },
    score_t: {
        color: 'rgba(0,0,0,0.85)',
        fontSize: pt(14)
    },
    score: {
        color: '#F56A00',
        fontSize: pt(14)
    },
    right_arrow: {
        width: pt(4),
        height: pt(10)
    },
    addr_box: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: pt(82),
        marginBottom: pt(4)
    },

    line: {
        marginBottom: pt(2),
        // justifyContent: 'space-between',

        alignItems: 'center',
        flexDirection: 'row'
    },
    fee: {
        // borderColor: '#bbb',
        // marginTop: pt(10)
    },
		detail_txt: {
				fontSize: pt(12),
				color: '#898989'
		},
    txt_title: {
        color: '#898989'
        // width: pt(67)
    },
    detail_d: {
        color: '#898989'
    },
    detail_tbox: {
        marginBottom: pt(5)
    },
    detail_box: {
        paddingTop: pt(13),
        marginLeft: pt(10),
        marginRight: pt(10),
        borderTopColor: 'rgba(0,0,0,0.1)',
        borderTopWidth: pt(1)
    },
    detail_t: {
        fontSize: pt(16),
        color: 'rgba(0,0,0,0.85)'
    },
    btn_box: {
        marginTop: pt(18),
        paddingBottom: pt(38),
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
		new_btn_box: {
				borderRadius: pt(4),
				flexDirection: 'row',
				justifyContent: 'space-between',
				backgroundColor: '#ffffff',
				height: pt(36),
				lineHeight: pt(36)
		},
		onlineBottom: {
				padding: pt(12)
		},
		fixedBottom: {
				display: 'flex',
				paddingTop: 100
		},
		fixedTips: {
				padding: pt(14),
				flexDirection: 'row',
				flexWrap: 'wrap',
				paddingTop: 0
		},
		fiexdText: {
				fontSize: pt(12),
				color: '#333'
		},
		fiexdTextBlue: {
				color: 'blue'
		},
    btn: {
		    justifyContent: 'center',
		    alignItems: 'center',
		    height: pt(36),
		    borderColor: '#bbb',
		    borderWidth: pt(1),
		    borderRadius: pt(4),
		    fontWeight: "600",
		    fontSize: pt(12),
		    color: 'rgba(51,51,51,1)'
    },
    btn_text: {
		    color: '#333',
		    fontSize: pt(12),
		    fontWeight: '600'
    },
    licence: {
        position: 'relative',
        flexDirection: 'row',
        // padding: pt(10),
        height: pt(44),
        paddingHorizontal: pt(15),
        marginTop: pt(15),
        marginBottom: pt(15),
        alignItems: 'center'
    },
    licence_text: {
        fontSize: pt(12),
        color: '#898989'
    },
    blue: {
        fontSize: pt(12),
        color: '#60A8FE'
    },
    nav_btn: {
        width: pt(14),
        height: pt(14)

        // marginHorizontal: pt(8),
        // resizeMode: 'contain'
    },
    shareicon: {
        position: 'absolute',
        right: pt(2),
        top: pt(6)
    }
});

const score = state => {
    const { starLevel } = state.orderDetail;

    return { starLevel };
};

OrderAddr.contextTypes = {
    router: PropTypes.object
};

export default connect(score, null, null, { withRef: true })(OrderAddr);
